import AssignmentDetails from './AssignmentDetails';

export default AssignmentDetails;
